<div class="card">
    <div class="card-header d-flex align-items-center justify-content-between">
        <div>
        <h5 class="mb-0">Clientes que no han comprado</h5>
        <small class="text-muted">Consulta clientes y filtra por NIT / Nombre</small>
        </div>

        <div class="d-flex gap-2">
        <button class="btn btn-outline-secondary" (click)="clear()" [disabled]="loading">
            Limpiar
        </button>

        <button class="btn btn-primary" (click)="fetchClients()" [disabled]="loading">
            <span *ngIf="!loading">Consultar clientes</span>
            <span *ngIf="loading">Consultando...</span>
        </button>
        </div>
    </div>

    <div class="card-body">

        <div *ngIf="!loaded" class="text-muted">
        Presiona <b>Consultar clientes</b> para obtener los datos.
        </div>

        <ng-container *ngIf="loaded">

        <div class="row g-2 mb-3" *ngIf="rows.length > 0">
            <div class="col-12 col-md-6">
                <label class="form-label mb-1">Filtrar (NIT o Nombre)</label>
                <input
                type="text"
                class="form-control"
                [(ngModel)]="filter"
                placeholder="Ej: 7616333, Juan..."
                />
            </div>

            <div class="col-12 col-md-6 d-flex align-items-end">
                <div class="legend w-100">
                <span class="badge badge-green me-2">0–4 días</span>
                <span class="badge badge-yellow me-2">5–9 días</span>
                <span class="badge badge-red">10+ días</span>
                </div>
            </div>
        </div>

        <div *ngIf="rows.length === 0" class="text-muted">
            No hay clientes para mostrar.
        </div>

        <div *ngIf="rows.length > 0" class="table-responsive">
            <table class="table table-sm table-hover align-middle">
            <thead>
                <tr>
                <th>Cliente</th>
                <th>NIT</th>
                <th>Última compra</th>
                <th class="text-end">Días</th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let r of filteredRows" [ngClass]="rowClass(r.daysSinceLastPurchase)">
                <td>
                    <div class="fw-semibold">{{ r.name }}</div>
                </td>

                <td>{{ r.nit }}</td>

                <td>
                    <!-- si viene como Date o string compatible, date pipe funciona -->
                    {{ r.lastPurchaseDate | date:'yyyy-MM-dd' }}
                </td>

                <td class="text-end fw-bold">
                    {{ r.daysSinceLastPurchase }}
                </td>
                </tr>

                <tr *ngIf="filteredRows.length === 0">
                <td colspan="4" class="text-muted">
                    No hay resultados con los filtros actuales.
                </td>
                </tr>
            </tbody>
            </table>
        </div>

        </ng-container>
    </div>
</div>
